import soundSrc from '@app/assets/sounds/new-message-sound.mp3';

let audio: HTMLAudioElement | null = null;
let lastPlayed = 0;

export function playLeadsUpdateSound(throttleMs = 1500, volume = 1) {
  const now = Date.now();
  if (now - lastPlayed < throttleMs) return;

  if (!audio) {
    audio = new Audio(soundSrc);
    audio.preload = 'auto';
    audio.volume = volume;
  } else {
    audio.volume = volume;
  }

  lastPlayed = now;

  audio.currentTime = 0;
  audio?.play();
}
